import React from 'react';

const ConsultingPage = () => {
  return (
    <div>
      <h1>Consulting</h1>
    </div>
  );
};

export default ConsultingPage;
